module.exports = __webpack_public_path__ + "img/昌黎葡萄酒.268bcc68.jpg";